// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollPatientRequestModel {
    static getAttributeTypeMap() {
        return EnrollPatientRequestModel.attributeTypeMap;
    }
}
EnrollPatientRequestModel.discriminator = undefined;
EnrollPatientRequestModel.additionalProperties = false;
EnrollPatientRequestModel.attributeTypeMap = [
    {
        "name": "account",
        "baseName": "account",
        "type": "EnterpriseCoordinatorAccountUpsearchRequestModel"
    },
    {
        "name": "surveys",
        "baseName": "surveys",
        "type": "Array<Survey>"
    },
    {
        "name": "shouldVerifyEligibility",
        "baseName": "shouldVerifyEligibility",
        "type": "boolean"
    },
    {
        "name": "payorCoverageAreas",
        "baseName": "payorCoverageAreas",
        "type": "Array<PayorCoverageEligibilityRequestModel>"
    },
    {
        "name": "enrollmentInput",
        "baseName": "enrollmentInput",
        "type": "ScriptsEnrollmentEnrollPatientEnrollmentInputModel"
    },
    {
        "name": "caseInitiator",
        "baseName": "caseInitiator",
        "type": "EnrollPatientCaseInitiator"
    },
    {
        "name": "caseSource",
        "baseName": "caseSource",
        "type": "EnrollPatientCaseSource"
    },
    {
        "name": "accountAttestations",
        "baseName": "accountAttestations",
        "type": "Array<EnrollPatientAccountAttestationAttribute>"
    },
];
//# sourceMappingURL=enrollPatientRequestModel.js.map